import type { ParsedAsset } from '@aikoa/common'
import { View } from 'react-native'
import PropertyCard from '~/components/assets/PropertyCard.tsx'
import { PhaseWrapper } from '~/components/flows/phases/PhaseWrapper.tsx'
import { SectionContent, ViewTitle } from '~/components/layout/Sections.tsx'

export interface ConfirmationPhaseProps {
  asset: ParsedAsset
  title: string
  description: string
}

export function ConfirmationPhase({ asset, title, description }: ConfirmationPhaseProps) {
  return (
    <PhaseWrapper>
      <View className="gap-2">
        <ViewTitle>{title}</ViewTitle>
        <SectionContent>{description}</SectionContent>
      </View>
      <PropertyCard asset={asset} />
    </PhaseWrapper>
  )
}
